import React, { useState, useEffect } from "react";
import HttpService from "../../services/httpService";
import { connect, useSelector } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { getAllRoles } from "../../redux/actions/rolesActions";
import {
    Table,
    Button,
    TableBody,
    TableCell,
    TableContainer,
    Checkbox,
    TableHead,
    TableRow,
    TextField,
    Paper,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Slide,
    FormControlLabel,
} from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { DeleteOutlined, ToolOutlined, EditOutlined } from "@ant-design/icons";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import { Modal } from "antd";
import Input from "@material-ui/core/Input";
import ListItemText from "@material-ui/core/ListItemText";
// import 'antd/dist/antd.css';
import Switch from "@material-ui/core/Switch";
import { salesDepartment, designDepartment } from "../../utils";
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 850,
    },
    textField: {
        width: 100,
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
}));
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#ccc",
        color: theme.palette.common.black,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const FactoryFinanceExecutive = (props) => {
    const classes = useStyles();

    useEffect(() => {
        fetchAllFinanceExecutive();
        getDepartments();
        getLocationList();
        getExperienceCenters();
        // eslint-disable-next-line
    }, []);

    const [users, setUsers] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [searchField, setSearchField] = useState("");
    const { rolesList } = useSelector((state) => state.roles);
    const [cities, setCities] = useState([]);
    const [dumpCities, setDumpCities] = useState([]);
    const [selectedCities, setSelectedCities] = useState([]);
    const [expcenters, setExpcenters] = useState([]);
    const [dumpExpCenters, setDumpExpcenters] = useState([]);
    const [selectedExpcenters, setSelectedExpcenters] = useState([]);
    const [checked, setChecked] = useState({ isActive: true });
    const [open, setOpen] = useState(false);
    const [userId, setUserId] = useState("");
    const [departmentLists, setDepartmentsList] = useState([]);
    const [dupDepartmentLists, setDupDepartmentList] = useState([]);
    const [department, setSelectedDepartment] = useState("");
    const [team, setSelectedTeam] = useState("");
    const [am, setSelectedAM] = useState("");
    const [teamLists, setTeamList] = useState([]);
    const [amList, setAMList] = useState([]);
    const [addUserModal, setAddUserModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [userDetails, setUserDetails] = useState({
        name: "",
        mobile: "",
        email: "",
        password: "",
        confirmPassword: "",
        _id: "",
    });
    const { name, mobile, email, password, confirmPassword } = userDetails;
    const [isPasswordShort, setIsPasswordShort] = useState(false);
    const [isConfirmPasswordMatched, setIsConfirmPasswordMatched] =
        useState(true);
    const [passwordStrength, setPasswordStrength] = useState("");
    const [passwordStrengthColor, setPasswordStrengthColor] = useState("red");
    const [rolesModal, setRolesModal] = useState(false);
    const [selectedUserRoles, setSelectedUserRoles] = useState([]);

    const fetchAllFinanceExecutive = async () => {
        props.setLoading(true);
        try {
            setChecked((prev) => !prev);
            let store = {};
            if (checked) {
                store.isActive = false;
            } else {
                store.isActive = true;
            }
            const result = await HttpService.getAllFinanceExecutive(store);
            for(let el of result.data){
                if(el.roles.find((role) => role.name === "Factory Finance Executive")){
                    el.isFactoryFinanceExecutive = true;
                }else {
                    el.isFactoryFinanceExecutive = false;
                }
            }
            setUsers(result.data);
            setUsersList(result.data);
        } catch (error) {
            console.error(error);
            props.setSnackInfo(
                error?.response?.data ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    const assignFactoryFinanceExecutiveRoleHandler = async (event, userId) => {
        props.setLoading(true);
        try {
            const roleId = rolesList.find((role) => role.name === name)?._id;
            await HttpService.roleAssignFactoryFinanceExecutive({
                action: event.target.checked,
                userId: userId,
            });
            props.setSnackInfo("User Role Updated", "success");
            fetchAllFinanceExecutive();
        } catch (error) {
            console.error(error);
            props.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    const getDepartments = async () => {
        try {
            props.setLoading(true);
            const department = await HttpService.getDepartments();
            let dept = [];
            department.data.forEach((ele) => {
                dept.push({ name: ele.name, _id: ele._id });
            });
            setDepartmentsList(dept);
            setDupDepartmentList(department.data);
        } catch (error) {
            console.error(error, "get department error");
        }
        props.setLoading(false);
    };

    const getTeamsList = async (deptid) => {
        try {
            let teams = dupDepartmentLists.filter((ele) => ele._id === deptid);
            const activeTeams = teams[0]["teams"].filter(
                (team) => team.isActive === true
            );
            setTeamList(activeTeams);

            const assistantManagers = teams[0]["users"]
                .filter((user) =>
                    user.roles.some(
                        (role) =>
                            role.name === "Assistant Sales Manager" ||
                            role.name === "Assistant Design Manager"
                    )
                )
                .map((user) => ({ id: user._id, name: user.name }));
            setAMList(assistantManagers);
        } catch (error) {
            console.error("Error in getTeamsList:", error);
        }
    };

    const getLocationList = async () => {
        props.setLoading(true);
        try {
            const response = await HttpService.getLocationList();
            let citi = [];
            response.data.forEach((ele, i) => {
                citi.push({
                    name: ele.name,
                });
            });
            setDumpCities(citi);
            setCities(response.data);
        } catch (error) {
            props.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    const getExperienceCenters = async () => {
        props.setLoading(true);
        try {
            const response = await HttpService.getExpericenCenters();
            setExpcenters(response.data);
        } catch (error) {
            props.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    return (
        <div>
            <div
                style={{
                    marginBottom: 20,
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Paper className={classes.paper}>
                    <center>
                        <h2>Factory Finance Executive</h2>
                    </center>
                </Paper>
            </div>
            
            <TableContainer component={Paper}>
                <Table
                    className={classes.table}
                    size="small"
                    aria-label="customized table"
                >
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Sl No</StyledTableCell>
                            <StyledTableCell>Name</StyledTableCell>
                            <StyledTableCell>ExperienceCenter</StyledTableCell>
                            <StyledTableCell>Email</StyledTableCell>
                            <StyledTableCell>Department</StyledTableCell>
                            <StyledTableCell>Team</StyledTableCell>
                            <StyledTableCell>Factory Finance Executive</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users?.map((data, i) => (
                            <StyledTableRow key={i + 1}>
                                <StyledTableCell>{i + 1}</StyledTableCell>
                                <StyledTableCell>{data?.name}</StyledTableCell>
                                <StyledTableCell>
                                    {data.experienceCenterId.map((el) =>
                                        el?.name ? el?.name + " " : "-"
                                    )}
                                </StyledTableCell>
                                <StyledTableCell>{data?.email}</StyledTableCell>
                                <StyledTableCell>
                                    {data?.departmentId?.name}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {data?.teamId?.name}
                                </StyledTableCell>
                                <StyledTableCell>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={data.isFactoryFinanceExecutive}
                                                onChange={(event) =>
                                                    assignFactoryFinanceExecutiveRoleHandler(event, data._id)
                                                }
                                                name="isActive"
                                                color="primary"
                                            />
                                        }
                                    />
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo, getAllRoles })(FactoryFinanceExecutive);